import API from "../../API";
import { showToast } from "../../Controllers/Toast";
import {
  ADD_TO_CART_PRODUCTS,
  GET_ALL_PRODUCTS,
  HANDLE_ERROR,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_FAILED,
  UPDATE_PRODUCT_REQUEST,
} from "../action.type";

export const getAllProducts = (page, limit, search, category, tabValue, published, filter) => {
  return async (dispatch) => {
    try {
      const apiCall = await API({
        url: "/admin/pos/getscannedProducts",
        method: "get",
        params: { page, limit, searchkey: search, category, key: tabValue, published, filter },
      });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        dispatch({
          type: GET_ALL_PRODUCTS,
          payload: apiCall?.data,
        });
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
    }
  };
};
export const getScannedBarcodeProduct = (barcode) => {
  return async (dispatch) => {
    try {
      const apiCall = await API({
        url: "/admin/pos/getScannedBarcodeProduct",
        method: "get",
        params: { barcode },
      });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        return apiCall;
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
    }
  };
};
export const getMembershipProduct = () => {
  return async (dispatch) => {
    try {
      const apiCall = await API({ url: "/admin/pos/getMembershipProduct", method: "get" });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        dispatch({
          type: GET_ALL_PRODUCTS,
          payload: apiCall,
        });
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
    }
  };
};

export const addToCartProduct = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ADD_TO_CART_PRODUCTS,
        payload: data,
      });
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
    }
  };
};
export const updateProduct = (id, data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PRODUCT_REQUEST,
        payload: null,
      });
      const apiCall = await API({
        url: `/admin/product/updateProduct/${id}`,
        method: "put",
        data: data,
      });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        showToast.success("Product updated successfully!");
        dispatch(getAllProducts(1, 25, "", "", ""));
        dispatch({
          type: UPDATE_PRODUCT,
          payload: apiCall?.data,
        });
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
      dispatch({
        type: UPDATE_PRODUCT_FAILED,
        payload: error,
      });
    }
  };
};
